import { cn } from "@nexus/ui"
import { useTranslation } from "react-i18next"

interface StoryboardArtDirectionNoteProps {
  className?: string
  /** Match the animatic column when the note sits under a centered player. */
  alignWithPlayer?: boolean
}

/**
 * Footnote under animatic frames — peripheral caption, never a content-area banner.
 */
export function StoryboardArtDirectionNote({
  className,
  alignWithPlayer = false,
}: StoryboardArtDirectionNoteProps) {
  const { t } = useTranslation()

  return (
    <p
      role="note"
      className={cn(
        "text-[10px] leading-snug text-muted-foreground/65",
        alignWithPlayer && "mx-auto w-full max-w-xs text-center",
        className,
      )}
    >
      {t(
        "opportunities.scripts.storyboard.animatic.notRealArtDirection",
        "Not final art direction.",
      )}
    </p>
  )
}
